<template>
  <v-card shaped class="elevation-3 rounded-xl mt-0 overflow-hidden">
    <div class="pt-8 pb-4 px-6">
      <v-card-text class="pt-0 pb-1">
        <div
          v-if="loginParams.productlogo.show"
          class="d-flex flex-column align-center mb-8 mt-4"
        >
          <img
            :src="loginParams.productlogo.src"
            :alt="loginParams.productlogo.title"
            style="max-width: 120px; margin-bottom: 16px;"
          />
          <h2
            style="color: #154669; font-weight: 500; text-align: center;"
            class="mb-0 font-weight-bold"
          >
            {{ $t('LoginToYourAccount') }}
          </h2>
        </div>

        <div class="d-flex justify-center mb-2">
          <div style="width: 300px;">
            <v-form
              id="check-login-form"
              @submit.prevent="login"
              class="mt-4"
            >
              <v-text-field
                v-model="model.username"
                :placeholder="$t('Login')"
                prepend-inner-icon="mdi-account"
                dense
                name="login"
                type="text"
                solo
                class="mb-6 rounded-lg radius-color"
                hide-details="auto"
              />

              <v-text-field
                name="password"
                :placeholder="$t('Password')"
                id="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="model.password"
                prepend-inner-icon="mdi-lock"
                solo
                dense
                class="mb-3 rounded-lg radius-color"
                hide-details="auto"
              />

              <div class="d-flex justify-end mt-2 mb-3">
                <a
                  class="grey--text text--blue-grey-lighten-4 caption text-decoration-none"
                  href="#"
                  @click="recover"
                  style="font-size: 12px;"
                >
                  {{ $t("LoginProblems") }}
                </a>
              </div>
            </v-form>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="d-flex justify-center">
        <div style="width: 300px;">
          <v-btn
            type="submit"
            form="check-login-form"
            block
            color="#154669"
            @click="login"
            :loading="loading"
            :disabled="!isFormValid"
            :height="45"
            class="text-none font-weight-medium position-relative d-flex justify-center align-center mb-1 rounded-lg"
            elevation="2"
          >
            <span class="text-white font-weight-bold flex-grow-1 text-center text-h4">
              {{ $t("SignIn") }}
            </span>
            <v-avatar color="primary" size="24" class="position-absolute" style="right: 12px;">
              <v-icon size="16" color="white">mdi-arrow-right</v-icon>
            </v-avatar>
          </v-btn>
        </div>
      </v-card-actions>

      <template v-if="modifiedSaml ? modifiedSaml : loginParams.saml.show">
        <div
          class="divider-with-text mx-auto text-center"
          style="max-width: 300px;"
        >
          <span class="caption grey--text">{{ $t('ContinueWith') }}</span>
        </div>
        <v-card-actions class="d-flex justify-center">
          <div style="width: 300px;">
            <v-btn
              block
              :loading="loading"
              :height="45"
              @click="samlLogin"
              class="text-none rounded-lg custom-login-button"
            >
              <img
                :src="modifiedSaml ? modifiedSamlLogo : loginParams.saml.iconSrc"
                class="mr-3"
                style="max-height: 15px;"
              />
            </v-btn>
          </div>
        </v-card-actions>
      </template>

      <!-- Entra ID -->
      <v-card-actions v-if="loginParams.entraId && loginParams.entraId.show" class="px-6 pb-6">
        <v-btn
          outlined
          block
          color="primary"
          :loading="loading"
          :height="45"
          @click="signInWithEntraid"
          class="text-none"
        >
          <img
            :src="loginParams.entraId.iconSrc"
            :alt="this.$t('Entra ID')"
            style="object-fit: cover; max-height: 20px"
            class="mr-3"
          />
          {{
            loginParams.entraId.customText ||
            $t("SignInWith") + " Entra ID"
          }}
        </v-btn>
      </v-card-actions>
    </div>

      <div v-show="newsletter"
        class="newsletter-section pa-4"
        style="background-color: #00BCD4;"
      >
        <v-row align="center" justify="space-between">
          <v-col cols="12" md="4" class="d-flex align-center justify-center text-center">
            <h3 class="white--text font-weight-medium text-h5 mb-0">
              {{ $t('JoinNewsLetter') }}
            </h3>
          </v-col>

          <div class="d-flex align-stretch">
            <v-text-field
              v-model="localNewsletterEmail"
              placeholder="doc.series@gmail.com"
              solo
              flat
              dense
              hide-details
              class="newsletter-input rounded-lg flex-grow-1"
              height="40"
              @input="$emit('newsletter-email-changed', localNewsletterEmail)"
            />
            <v-btn
              type="submit"
              color="#2c3e50"
              class="text-none font-weight-bold px-6"
              :loading="newsletterLoading"
              :disabled="newsletterLoading"
              elevation="0"
              small
              height="40"
              style="border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important; border-radius: 0 8px 8px 0;"
  @click="$emit('subscribeNewsletter', localNewsletterEmail)"
            >
              <span class="white--text">{{ $t("Subscribe") }}</span>
            </v-btn>
          </div>
        </v-row>
      </div>
  </v-card>
</template>

<script>
export default {
    name: 'LoginForm',
    props: {
        loginParams: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        },
        isFormValid: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        modifiedSaml: {
            type: Boolean,
            default: false
        },
        modifiedSamlLogo: {
            type: String,
            default: null
        },
        newsletter: {
            type: Boolean,
            required: true
        },
        newsletterEmail: {
            type: String,
            default: ''
        },
        newsletterLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showPassword: false,
            localNewsletterEmail: this.newsletterEmail,
        };
    },
    methods: {
        login(e) {
            this.$emit('login', e);
        },
        recover() {
            this.$emit('recover');
        },
        samlLogin() {
            this.$emit('samlLogin');
        },
        signInWithEntraid() {
            this.$emit('signInWithEntraid');
        },
        subscribeNewsletter() {
            this.$emit('subscribeNewsletter', this.localNewsletterEmail);
        }
    },
    watch: {
        newsletterEmail(newVal) {
            this.localNewsletterEmail = newVal;
        },
    }
};
</script>

<style scoped lang="css">
.radius-color {
  transition: box-shadow 0.3s ease;
  box-shadow: none;
}

.radius-color.v-input--is-focused {
  box-shadow: 0 0 20px 5px rgba(103, 210, 224, 0.7);
}

.custom-login-button {
  border: 2px solid #BDBDBD !important;
  background-color: white !important;
  box-shadow: none;
}

.custom-login-button:hover,
.custom-login-button:focus {
  background-color: #BDBDBD !important;
}

.divider-with-text {
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
}

.divider-with-text::before,
.divider-with-text::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin: 0 8px;
}

.newsletter-input {
  border-radius: 8px 0 0 8px !important;
}
</style>
